/* eslint-disable import/no-anonymous-default-export */
const prod = process.env.NODE_ENV === "development";

// Admin url = 'https://saayamadmin.saayam.com/signin'

// Old API url = "https://saayamapi.saayam.com/api/"

// New url = 'http://3.94.78.3:8080/api/

// Mukund's IP: 192.168.0.173
// Satish's IP: 192.168.0.197
// Shruti's IP: 192.168.0.124

const mapKey = "AIzaSyDRZ9dub0xUqosNmQJIsFocRJ8WfOh8gSY"; // for location info

export default {
  siteName: "React",
  siteIcon: "ion-flash",
  footerText: `© ${new Date().getFullYear()} test`,

  apiUrl: "https://saayamapi.saayam.com/api/", //https://saayamadmin.saayam.com/
  stagingUrl: "https://saayamapi.saayam.com",
  siteUrl: "",
  csvUrl: "",
  editorKey: "9356bbr916nf50yu6wrw8pupq3awdbhl9yu64igztvgx0sa2",
  domainUrl: prod ? "" : "http://localhost:3000",
  sailsUrl: "http://localhost:33969/",
  MAP_KEY: mapKey,
  mapKey: "AIzaSyCw36Aoc0IeuI29CErnotECw_k5rDID0Uw", // For Direction
  GOOGLE_PLACE_API_KEY: "AIzaSyCp3JhjGUsHaUA-u9jLukB9ySDjxzzES7U", // For auto complete
  fireBaseVapidKey:
    "BC-5t68fvZTLgZQYBmE_MJ8S_eB9I0ZNWqqMj7TE987AFFu0Y8VV0NXiHyWJQQ7VQxYRhmqtFPcfot7kIknjY3I",

  google: {
    analyticsKey: "UA-xxxxxxxxx-1",
  },
  tinyEditorKey: "9356bbr916nf50yu6wrw8pupq3awdbhl9yu64igztvgx0sa2",
  dashboard: "/dashboard",
  tenantId: "saayam",
  socialCoreApiUrl: "https://api.aautisocial.com/",
  environmentType: "production",
};
